<template>
    <div class="row">
        <div class="col-md-12">
            <el-button-group>
                <el-button @click="filter('T')" size="small" :class="{'active-filter': filterText == 'T'}">
                    {{$t("todos")}}
                </el-button>
                <el-button @click="filter('C')" size="small" :class="{'active-filter': filterText == 'C'}"><i
                        class="fas fa-check-circle text-success"></i> {{$t("cobrado")}}
                </el-button>
                <el-button @click="filter('P')" size="small" :class="{'active-filter': filterText == 'P'}"><i
                        class="fas fa-map-pin text-warning"></i> {{$t("apuntado")}}
                </el-button>
                <el-button @click="filter('N')" size="small" :class="{'active-filter': filterText == 'N'}"><i
                        class="fa fa fa-times-circle"
                        style="color: darkred"></i> {{$t("anulado")}}
                </el-button>
                <el-button @click="filter('X')" size="small" :class="{'active-filter': filterText == 'X'}"><i
                        class="fa fa-exchange-alt" style="color: #808000"></i>
                    {{$t("cambio")}}
                </el-button>
                <el-button @click="filter('R')" size="small" :class="{'active-filter': filterText == 'R'}"><i
                        class="fas fa-retweet" style="color: red"></i>
                    Retirada
                </el-button>
                <el-button @click="filter('G')" size="small" :class="{'active-filter': filterText == 'G'}"><i
                        class="fa fa-shopping-cart text-primary"></i> {{$t("gastos")}}
                </el-button>
                <el-button @click="filter('A')" size="small" :class="{'active-filter': filterText == 'A'}"><i
                        class="fas fa fa-clock"></i> {{$t("aparcado")}}
                </el-button>
                <el-button @click="filter('I')" size="small" :class="{'active-filter': filterText == 'I'}"><i
                        class="fas fa-exclamation-circle text-danger"></i>
                    {{$t("incidencias")}}
                </el-button>
            </el-button-group>
            <template v-for="ticket in tickets">
                <ticket :ticket="ticket"></ticket>
            </template>
        </div>
    </div>
</template>
<script>
    import swal from 'sweetalert2'
    import Ticket from '../../../../Widgets/Ticket'
    import {
        Switch,
        DatePicker,
        Select,
        Option,
        ButtonGroup,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button
    } from 'element-ui'
    export default {
        created() {
            // //Con bases
            // this.getConfigTpvsub(95);
            // //con Opcionales
            // this.getConfigTpvsub(96);
            // //con Extras
            // this.getConfigTpvsub(97);
            this.getTickets();
        },
        props: ['idBusiness', 'idDay'],
        data() {
            return {
                tickets: [],
                filterText: "T",
                listTickets: [],
                withdrawals: [],
                // conBases:false,
                // conExtra:false,
                // conOpcionales:false,
            }
        },
        components: {
            Ticket,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [ButtonGroup.name]: ButtonGroup
        },
        methods: {
        // getConfigTpvsub(numConfig) {
        //     var config = {
        //         params: {
        //           idBusiness: this.idBusiness,
        //           jwt: this.$store.getters.jwt,
        //           numConfig: numConfig,
        //         },
        //         headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        //     };
        //     let respuesta=false;
        //     let vm = this;
        //     this.$store.dispatch("setIdBusiness", this.idBusiness);
        //     this.axios
        //         .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        //         .then(function(response) {
        //           respuesta = response.data.response;
        //           switch(numConfig) {
        //             case 95:
        //               vm.conBases = respuesta;
        //               //console.log("Base "+vm.conBases+" "+numConfig);
        //               break;
        //             case 96:
        //               vm.conOpcionales = respuesta
        //               //console.log("Opcional "+vm.conOpcionales+" "+numConfig);
        //               break;
        //             case 97:
        //               vm.conExtra = respuesta;
        //               //console.log("Extra "+vm.conExtra+" "+numConfig);
        //               break;
        //           }

        //         })
        //         .catch(function(error) {
        //             console.log(error);
        //         });
        //     },
            filter(filter) {
                if (filter !== null) {
                    this.filterText = filter;
                }

                let xList = [];
                let vm = this;

                if (this.filterText === "T") {
                    this.tickets = this.listTickets;

                } else if (this.filterText === "I") {
                    this.listTickets.forEach(function (x) {
                        if (x.numIssues > 0) {
                            xList.push(x);
                        }
                    });

                    this.tickets = xList;
                } else {
                    this.listTickets.forEach(function (x) {
                        if (x.status === vm.filterText) {
                            xList.push(x);
                        }
                    });

                    this.tickets = xList;
                }
            },
            
            getTickets() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idDay: this.idDay,
                        jwt: this.$store.getters.jwt,
                        allowAllBusiness: true
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "sales/getTicketsOfDay", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.tickets = response.data.result.tickets;
                            vm.listTickets = vm.tickets;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.getTickets();
            }
        },
    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }
    .title {
        font-weight: bold;
    }
    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }
    .card-category {
        color: #9a9a9a
    }
    .verTodos {
        font-size: 0.9em
    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Widgets/Tickets.vue